export function element(selector: string, parent: Element | Document = document): Element {
    return parent.querySelector(selector);
}
